import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=0805e565&scoped=true"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=0805e565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805e565",
  null
  
)

export default component.exports